import { create } from 'zustand';
import type { GetLobbyListQuery } from '../generated/gql/graphql';
import {
  executeGQL,
  Lobby,
  LobbyListQuery,
  LobbyQuery,
} from '../GraphQLHelpers';

interface LobbyStore {
  lobbyByID: Record<string, Lobby | null>;
  lobbyList: GetLobbyListQuery['lobby_list'] | null;

  storeLobby: (lobby: Lobby) => void;
  storeNullLobby: (lobbyID: string) => void;
  fetchLobby: (id: string, sequenceID: number) => Promise<void>;
  fetchLobbyList: () => Promise<void>;
}

export const useLobbyStore = create<LobbyStore>()((set, get) => ({
  lobbyByID: {},
  lobbyList: null,

  storeLobby: (lobby) => {
    set((state) => ({
      lobbyByID: { ...state.lobbyByID, [lobby.id]: lobby },
    }));
  },

  storeNullLobby: (lobbyID) => {
    set((state) => ({
      lobbyByID: { ...state.lobbyByID, [lobbyID]: null },
    }));
  },

  fetchLobby: async (id, sequenceID) => {
    const existing = get().lobbyByID[id];
    sequenceID = sequenceID || 0;
    if (existing && existing.sequenceID >= sequenceID) return;

    const result = await executeGQL(LobbyQuery, { id });
    if (!result.data) return;

    const lobby = result.data.lobby;
    if (lobby) {
      get().storeLobby(lobby);
    } else {
      get().storeNullLobby(id);
    }
  },

  fetchLobbyList: async () => {
    const result = await executeGQL(LobbyListQuery);
    if (!result.data) return;
    set({ lobbyList: result.data.lobby_list });
  },
}));
